import React, {useEffect, useState} from 'react'
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";

const ExternalMoMView = ({
                             history,
                             match,
                             momByIdRequest,
                             momByIdResponse = []
                         }) => {

    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await momByIdRequest(match?.params?.meeting_id)
            setIsLoading(false)
        })()
    }, [])

    console.log(momByIdResponse)
    return (
        <>
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"MOM View"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            <>
                                <div className="row">
                                    <div className="col-md-12">
                                        <>
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">Details</h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                        <input type="text"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               id="validationCustom01"
                                                               required
                                                               value={momByIdResponse?.to_email}
                                                        />
                                                        <label className="large-label float-lb">
                                                            To Email
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                        <input type="text"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               id="validationCustom01"
                                                               required
                                                               value={momByIdResponse?.cc_email}
                                                        />
                                                        <label className="large-label float-lb">
                                                            Cc Email
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                        <input type="text"
                                                               className="form-control form-control-user"
                                                               placeholder=" "
                                                               id="validationCustom01"
                                                               required
                                                               value={momByIdResponse?.subject}
                                                        />
                                                        <label className="large-label float-lb">
                                                            Subject
                                                        </label>
                                                    </div>
                                                    <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                        <textarea
                                                            className="form-control form-control-user"
                                                            placeholder="Body"
                                                            id="validationCustom01"
                                                            rows="4" cols="50"
                                                            value={momByIdResponse?.body}
                                                        />
                                                        <label className="large-label float-lb">
                                                            {/*Body*/}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <>
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                <h1 className="h3 mb-0 text-black-100">Agenda Details</h1>
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    {momByIdResponse?.agenda && momByIdResponse.agenda.map((item, index) => {
                                                        return (
                                                            <>
                                                                <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           id="validationCustom01"
                                                                           required
                                                                           value={item?.agenda}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Agenda
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           id="validationCustom01"
                                                                           required
                                                                           value={item?.timeline}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Timeline
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           id="validationCustom01"
                                                                           required
                                                                           value={item?.task}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Task
                                                                    </label>
                                                                </div>
                                                                <div className="col-sm-6 mtk-075 d-mtk-03 float-field">
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           id="validationCustom01"
                                                                           required
                                                                           value={item?.assigned_person}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Assigned Person
                                                                    </label>
                                                                </div>
                                                            </>
                                                        )
                                                    })}

                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExternalMoMView

